import { Navigate, useParams, useRoutes } from "react-router-dom";

import ListPage from "./list";

export default () =>
  useRoutes([
    { path: "/", element: <WithParameters component={ListPage}/> },
    { path: "/*", element: <Navigate to="/not-found"/> },
  ]);

function WithParameters({ component: Comp }) {
  const parameters = useParams();
  return <Comp {...parameters} />;
}
